import { render, staticRenderFns } from "./groupBuy-detail.vue?vue&type=template&id=7ee4b588&scoped=true&"
import script from "./groupBuy-detail.vue?vue&type=script&lang=ts&"
export * from "./groupBuy-detail.vue?vue&type=script&lang=ts&"
import style0 from "./groupBuy-detail.vue?vue&type=style&index=0&id=7ee4b588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee4b588",
  null
  
)

component.options.__file = "groupBuy-detail.vue"
export default component.exports